import styled from "styled-components";
import {COLORS} from "shared/consts";

export const ChartContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    
    @media screen and (max-width: 1000px) {
        padding-bottom: 80px;
    }
`

export const ChartHeader = styled.div`
    display: flex;
    gap: 14px;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    
    @media screen and (max-width: 1000px) {
        height: 44px;

        .segmentedcontrol {
            height: 100%;
        }
    }
`

export const DateInputChartWrapper = styled.div`
    .input {
        min-height: 28px !important;
    }
    &.active .input {
        background: ${COLORS.BG.SURFACE1};
    }
`

export const ChartRow = styled.div`
    display: flex;
    gap: 16px;
    
    @media screen and (max-width: 1000px) {
        flex-direction: column;
    }
`

export const ChartWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px;
    border-radius: 16px;
    background: var(--bg-surface1, rgba(255, 255, 255, 1));
    min-width: 0;
`

export const ChartAbsoluteCol = styled.div`
    display: flex;
    min-width: 320px;
    flex-direction: column;
    gap: 16px;
`

export const ChartAbsoluteBlock = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    height: max-content;
    border-radius: 16px;
    background: ${COLORS.BG.SURFACE1};
`

export const ChartAbsoluteHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding: 16px;
    border-bottom: 1px solid var(--border-muted, rgba(88, 93, 105, 0.15));
    
    
    h2 {
        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
    }
`

export const ChartAbsoluteMinMaxRow = styled.div`
    display: flex;
    gap: 12px;
`

export const ChartAbsoluteMinMaxCol = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    
    .input {
        width: 100%;
        min-width: 0;
        margin-top: 0;
    }
    
    .input__suffix {
        right: 0;
        margin: 0;
    }
    
    h3 {
        color: var(--input-primary-label-color-default, rgba(16, 24, 40, 0.75));
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
    }
`

export const ChartSwitchRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    p {
        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }
`

export const ChartAbsoluteFooter = styled.div`
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    
    p {
        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }
    
    .input {
        min-width: 180px;
        max-width: 180px;
    }
`

export const ChartMarksContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

export const ChartMarksTitleRow = styled.div`
    display: flex;
    
    h2 {
        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
    }
`

export const ChartMarkWrapper = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    @media screen and (max-width: 1000px) {
        flex-direction: column;
        gap: 16px;
    }
    
`

export const ChartMarkItem = styled.div`
    width: 320px;
    display: flex;
    flex-direction: column;

    border-radius: 16px;
    background: ${COLORS.BG.SURFACE1};
`

export const ChartMarkItemHeader = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--border-muted, rgba(88, 93, 105, 0.15));

`

export const ChartMarkItemTitleRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    
    h3 {
        margin-right: auto;
        margin-left: 6px;

        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
    }
`

export const ChartMarkItemColor = styled.span`
    border-radius: 50%;
    width: 8px;
    height: 8px;
    display: block;
    margin-right: 6px;
`

export const ChartMarkItemMore = styled.div`
   cursor: pointer;
    margin-left: auto;
    position: relative;
`

export const ChartMarkInputDesc = styled.div`
    margin-bottom: 4px;
    color: var(--input-primary-label-color-default, rgba(16, 24, 40, 0.75));
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
`

export const ChartMarkInput = styled.div`
    margin-bottom: 18px;
`

export const ChartMarkCreate = styled.div`
    width: 320px;
    border: 2px solid var(--button-outline-neutral-border-color-default, rgba(88, 93, 105, 0.15));
    border-radius: var(--button-l-border-radius, 16px);
    box-shadow: inset 0px 0px 0px 0px rgba(0, 0, 0, 0);
    background: var(--button-outline-neutral-bg-color-default, rgba(255, 255, 255, 0));

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    min-height: 48px;
    
    svg {
        width: 24px;
        height: 24px;
    }
    
    svg,path {
        fill: var(--button-outline-neutral-icon-color-default, rgba(88, 93, 105, 1));  
    }
`


export const ChartMarkFooter = styled.div`
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    
    p {
        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }
    
    .input {
        min-width: 180px;
        max-width: 180px;
    }
`

export const ChartActions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px;
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 10000;
    border-bottom: 1px solid var(--border-muted, rgba(88, 93, 105, 0.15));
    border-radius: var(--dropdownmenu-m-border-radius, 8px);
    box-shadow: 0px 32px 32px 0px var(--shadow-soft, rgba(88, 93, 105, 0.05)),0px 0px 32px 0px var(--shadow-muted, rgba(88, 93, 105, 0.1));
    background: var(--dropdownmenu-primary-bg-color, rgba(255, 255, 255, 1));
    p {
        color: var(--dropdownmenu-primary-itemvalue-color-default, rgba(16, 24, 40, 1));
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        
        cursor: pointer;
        padding: 8px 12px;
        
        &:last-of-type {
            color: var(--error-default, rgba(255, 38, 38, 1));
        }
        
        &:hover {
            background: #eaeaec;
            border-radius: var(--dropdownmenu-m-item-border-radius, 8px);
        }
    }
`

export const HiveMarkEditBG = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100dvh;
    overflow: hidden;
    z-index: 1000;
    
    display: flex;
    justify-content: center;
    align-items: center;
    
    background: rgba(16, 24, 40, .3);
`

export const HiveMarkEditWindow = styled.div`
    border-radius: 16px;
    background: ${COLORS.BG.SURFACE1};
    height: max-content;
    width: 504px;
    max-width: 90%;
`

export const HiveMarkEditWindowHeader = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px;

    border-bottom: 1px solid var(--border-muted, rgba(88, 93, 105, 0.15));
`

export const HiveMarkEditWindowTitleRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 32px;
    
    h3 {
        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
    }
    
    svg {
        cursor: pointer;
    }
`

export const HiveMarkEditWindowInfoRow = styled.div`
    display: flex;
    gap: 33px;

    @media screen and (max-width: 1000px) {
        flex-direction: column;
        gap: 12px;
    }
`

export const HiveMarkEditWindowInfoCol = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    
    width: 100%;
    > p {
        color: var(--input-primary-label-color-default, rgba(16, 24, 40, 0.75));
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
    }
    
    .input {
        min-width: 0;
        width: 100%;
        margin-top: 0;
    }
    
`

export const HiveMarkEditWindowFooter = styled.div`
    display: flex;
    gap: 12px;
    padding: 16px;
    
    .button {
        width: 100%;
    }
`